module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.7d4ab6b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-chevron-down.svg
// module id = 726
// module chunks = 21